import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ERC20_ABI } from '@/abi';
import { useWeb3Context } from '@/contexts';
import { useOnceShowup } from '@/hooks';
import { ZERO, ZERO_ADDRESS } from '@/lib';
import { formatBalance, getStorage, StorageKeys } from '@/utils';
import classnames from 'classnames';
import { Contract } from 'ethers';
import { useRef, useState } from 'react';
import { useAsyncFn } from 'react-use';
import { LoadingIcon } from '../Icon';
import { TokenIcon } from '../TokenIcon';
import { useLocales } from '../useLocales';
import styles from './index.module.less';
export * from './ERC721ContractList';
// TODO refactor with vitual list
export const TokenList = ({ tokens, className, onPick, ...rest }) => {
    const storedERC721Tokens = getStorage(StorageKeys.ERC20Tokens) ?? [];
    const addresses = storedERC721Tokens.map((t) => t.address);
    return (_jsx("ul", { className: classnames(styles.list, className), ...rest, children: tokens.map((token) => (_jsx("li", { className: styles.item, role: "button", onClick: () => onPick?.(token), children: _jsx(Token, { isCustomized: addresses.includes(token.address), token: token }) }, token.address))) }));
};
export const Token = ({ token, isCustomized, onClick, hideBalance, className, ...rest }) => {
    const t = useLocales();
    const { account, ethersProvider } = useWeb3Context();
    const containerRef = useRef(null);
    const [balance, setBalance] = useState(ZERO);
    const [{ loading }, fetchBalance] = useAsyncFn(async () => {
        if (!ethersProvider || !account)
            return;
        if (token.address === ZERO_ADDRESS) {
            const balanceResult = await ethersProvider.getBalance(account);
            setBalance(balanceResult);
            return;
        }
        else {
            const contract = new Contract(token.address, ERC20_ABI, ethersProvider);
            const balanceResult = await contract.balanceOf(account);
            setBalance(balanceResult);
        }
    }, [account, token.address, ethersProvider]);
    useOnceShowup(containerRef, fetchBalance);
    return (_jsxs("div", { className: classnames(styles.token, className), onClick: onClick, ref: containerRef, ...rest, children: [_jsx("div", { className: styles.icon, children: _jsx(TokenIcon, { height: "24", width: "24", token: token }) }), _jsxs("div", { className: styles.info, children: [_jsx("div", { className: styles.symbol, children: token.symbol }), _jsxs("div", { className: styles.name, children: [token.name, isCustomized && ` • ${t('Added by uesr')}`] })] }), !hideBalance && (_jsx("div", { className: styles.balance, children: loading ? _jsx(LoadingIcon, { size: 24 }) : formatBalance(balance, token.decimals || 1, 4) }))] }));
};
